export default __webpack_public_path__ + "static/media/cancer-OFF.caab1e4e.png";